import React, { FunctionComponent, useEffect, useRef, useState, } from "react";
import { connect, useDispatch } from "react-redux";
import SetupWhatsappTemplates from "./SetupWhatsappTemplates";
import Templates from "./Templates";
import NewWhatsappBroadcast from "./NewWhatsappBroadcast";
import { useLocation } from "react-router-dom";
import { canAccessMarketingAutomationModule } from "../../Services/marketingAutomation";
import { setAccessMAStatus,setCurrentRoute } from "../../Redux/actions";
import MarketingScreenNew from "../MarketingPanel/MarketingScreenNew";

type props = {
    accessAllowedMarketingAutomation: boolean;
    history: any;
    user: any;
};

const Marketing: FunctionComponent<props> = ({accessAllowedMarketingAutomation,  history, user}) => {
    const location: any = useLocation();
    const dispatcher = useDispatch();

    const [cRoute,setCRoute]=useState("") 

                  useEffect(() => {
                    dispatcher(setCurrentRoute(location.pathname))
                    setCRoute(location.pathname)
                  }, [location]);

      useEffect(() => {
        const setAccessMarketingAutomationModule = async () => {
          let access = await canAccessMarketingAutomationModule(user.organization_id);
          dispatcher(setAccessMAStatus({ accessAllowedMarketingAutomation: access }));
        };
    
        if (user.organization_id) {
          setAccessMarketingAutomationModule();
        }
      }, [
        user.organization_id
      ]);

    useEffect(()=>{
        if(accessAllowedMarketingAutomation === false){
            history.push("/");
        }
    },[accessAllowedMarketingAutomation])

    return (
        <>
        {
                accessAllowedMarketingAutomation &&
                (
                    location.state && location.state.showSetupScreen ?
                        <SetupWhatsappTemplates />
                        :
                        <MarketingScreenNew />
                )
        }
          {/* <Templates /> */}
          {/* <NewWhatsappBroadcast /> */}
        </>
    );
};

const mapStateToProps = (state: any) => {
    return {
        accessAllowedMarketingAutomation: state.organization.accessAllowedMarketingAutomation,
        user: state.user.data,
    };
};

export default connect(mapStateToProps)(Marketing);